import { Component, input, ElementRef, ChangeDetectionStrategy, output, inject, viewChild } from '@angular/core';
import { Transaction, Bucket, DeleteTransfersAction } from '../../types';
// import * as clamp from 'clamp-js';
import { ConfirmDialogComponent } from '../../dialog-templates/confirm-dialog/confirm-dialog.component';
import { TransactionDataSource } from '../transaction-data-source.class';
import { UiDialogService } from '../../ui/dialog/dialog.service';
import { EditTransactionListItemComponent } from '../edit-transaction-list-item/edit-transaction-list-item.component';
import { CurrencyPipe } from '@angular/common';
import { UiButtonDirective } from '../../ui/button/button.directive';
import { NgIcon } from '@ng-icons/core';
import { HlmIcon } from '../../ui/helm/icon/src/lib/hlm-icon';
import { UiCheckboxComponent } from '../../ui/checkbox/checkbox.component';
import { TransactionListItemContentComponent } from '../transaction-list-item-content/transaction-list-item-content.component';
import { merchantInitial } from '../../transaction-rules/transaction-rule-display';

@Component({
  selector: 'app-transaction-list-item',
  templateUrl: './transaction-list-item.component.html',
  styleUrl: './transaction-list-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiButtonDirective, NgIcon, HlmIcon, UiCheckboxComponent, TransactionListItemContentComponent, CurrencyPipe],
})
export class TransactionListItemComponent {
  private dialog = inject(UiDialogService);

  readonly transaction = input.required<Transaction>();
  readonly transactionDataSource = input<TransactionDataSource | null>(null);
  readonly buckets = input<Bucket[]>([]);
  readonly bucketIdentities = input<Bucket[]>([]);
  readonly isSelected = input(false);
  readonly selectionMode = input(false);
  readonly showBucketSelector = input(true);
  readonly interactive = input(true);
  readonly selectionToggled = output<{ isSelected: boolean; transaction: Transaction }>();
  readonly element = viewChild<ElementRef>('element');

  // ngAfterViewInit() {
  // const nativeElement = this.element.nativeElement;
  // if (nativeElement) {
  //   const merchantName = nativeElement.querySelector('.transaction-list-item-merchant');
  //   const accountDetails = nativeElement.querySelector('.transaction-list-item-account');
  //   // // console.log(merchantName, accountDetails);
  //   // if (merchantName) clamp(merchantName, { clamp: 2 });
  //   // if (accountDetails) clamp(accountDetails, { clamp: 1 });
  // }
  // }

  transactionSelectionToggled() {
    if (!this.interactive()) return;
    this.selectionToggled.emit({ isSelected: !this.isSelected(), transaction: this.transaction() });
  }

  shouldShowSelectionCheckbox() {
    return this.selectionMode() || this.isSelected();
  }

  merchantDisplayName() {
    return this.transaction().merchantMeta?.displayName || this.transaction().merchant;
  }

  merchantLogoUrl() {
    return this.transaction().merchantMeta?.logoUrl || null;
  }

  merchantInitial() {
    return merchantInitial(this.merchantDisplayName());
  }

  whyLocked(reason: string) {
    const reasons: Record<string, string> = {
      ARCHIVED_BUCKET: 'This transaction is locked, because it is in an archived budget.',
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: reasons[reason],
        confirmColor: 'primary',
        onConfirm: () => {},
      },
    });
  }

  openDeleteTransferModal(_transfer: Transaction) {
    const transactionDataSource = this.transactionDataSource();
    if (!this.interactive() || !transactionDataSource) return;
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: 'Are you sure you want to delete this transfer?',
        cancelText: 'Cancel',
        confirmText: 'Delete',
        confirmColor: 'warn',
        onConfirm: () => {
          const action: DeleteTransfersAction = { type: 'DELETE_TRANSFERS', value: [this.transaction()] };
          transactionDataSource.dispatch(action);
        },
      },
    });
  }

  selectedBucketChange(bucket: Bucket) {
    this.transaction().selectedBucket = bucket;
  }

  openEditTransactionModal() {
    const transactionDataSource = this.transactionDataSource();
    if (!this.interactive() || !transactionDataSource) return;
    this.dialog.openModal(EditTransactionListItemComponent, {
      ariaLabel: `Edit transaction ${this.transaction().merchant}`,
      layout: 'fullscreen-mobile',
      backdropClass: 'bg-black/40',
      closeOnOutsidePointerEvents: false,
      data: {
        transaction: this.transaction(),
        transactionDataSource,
      },
    });
  }
}
